export const CATEGORIES = [
  'Food',
  'Transport',
  'Shopping',
  'Education',
  'Bills',
  'Entertainment',
  'Health',
  'Travel',
  'Other',
] as const;

export type Category = (typeof CATEGORIES)[number];

export const PAYMENT_METHODS = [
  'Cash',
  'UPI',
  'Debit card',
  'Credit card',
  'Bank transfer',
  'Other',
] as const;

export type PaymentMethod = (typeof PAYMENT_METHODS)[number];
export type Theme = 'light' | 'dark';
export type Page = 'home' | 'history' | 'statistics' | 'settings';
export type SyncStatus = 'local' | 'pending' | 'synced' | 'error';
export type Recurrence = 'daily' | 'weekly' | 'monthly';
export type TransactionKind = 'outflow' | 'inflow';

export interface Expense {
  id: string;
  name: string;
  amount: number;
  kind: TransactionKind;
  category: Category;
  occurredAt: string;
  paymentMethod: PaymentMethod;
  notes: string;
  createdAt: string;
  updatedAt: string;
  syncStatus: SyncStatus;
  recurringId?: string;
}

export interface RecurringExpense {
  id: string;
  name: string;
  amount: number;
  category: Category;
  paymentMethod: PaymentMethod;
  notes: string;
  cadence: Recurrence;
  monthlyDay?: number;
  reminderEnabled: boolean;
  reminderHoursBefore: number;
  nextDueAt: string;
  active: boolean;
  createdAt: string;
}

export interface Settings {
  currency: string;
  monthlyBudget: number;
  shakeEnabled: boolean;
  shakeSensitivity: number;
  defaultPaymentMethod: PaymentMethod;
  theme: Theme;
  syncEnabled: boolean;
  sheetsConnected: boolean;
  lastSyncAt: string | null;
  alertThreshold: number;
  notificationsEnabled: boolean;
}

export interface AppState {
  version: 1;
  expenses: Expense[];
  recurringExpenses: RecurringExpense[];
  settings: Settings;
  syncQueue: string[];
}

export interface ExpenseDraft {
  name: string;
  amount: string;
  kind: TransactionKind;
  category: Category;
  occurredAt: string;
  paymentMethod: PaymentMethod;
  notes: string;
}

export interface RecurringDraft {
  name: string;
  amount: string;
  category: Category;
  paymentMethod: PaymentMethod;
  notes: string;
  cadence: Recurrence;
  reminderEnabled: boolean;
  reminderHoursBefore: number;
  nextDueAt: string;
}
